import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import style from './Navigation.module.scss';

type TopNavItemWrapperProps = {
  children: ReactNode;
  classNameModifier?: string;
};

const TopNavItemWrapper: FC<TopNavItemWrapperProps> = ({
  children,
  classNameModifier,
}) => (
  <li className={getClassName(style, 'item', classNameModifier)}>
    {children}
  </li>
);

export default TopNavItemWrapper;
